import { Filter } from '@ami/react/core';

export class DealerUserFilter extends Filter {
  constructor(filter) {
    super();
    if (filter) {
      this.dealerUserId = filter.dealerUserId;
      this.search = filter.search;
      this.dealerGroupId = filter.dealerGroupId;
      this.dealerBranchId = filter.dealerBranchId;
      this.defaultDealerBranchId = filter.defaultDealerBranchId;
      this.registrationStatus = filter.registrationStatus;
      this.territoryManagerId = filter.territoryManagerId;
      this.includeRetired = filter.includeRetired;
      // These are just to pre-populate the async dropdowns.
      this.dealerGroupName = filter.dealerGroupName;
      this.dealerBranchName = filter.dealerBranchName;
      this.defaultDealerBranchName = filter.defaultDealerBranchName;
      return this;
    }
    this.dealerUserId = '';
    this.search = '';
    this.dealerGroupId = '';
    this.dealerBranchId = '';
    this.registrationStatus = '';
    this.territoryManagerId = '';
    this.includeRetired = false;
    this.dealerGroupName = '';
    this.dealerBranchName = '';
    this.defaultDealerBranchId = '';
    this.defaultDealerBranchName = '';
  }
}
